"use strict";
module.exports = require('../../module.compiled').vendored['contexts'].RouterContext;

//# sourceMappingURL=router-context.js.map